export const REPORT_TEMPLATES = ["overview", "analysis", "detail"] as const

// Shared by the template preview and insertion so both use the current free-placement geometry.
export function reportTemplateLayout(template: typeof REPORT_TEMPLATES[number], canvas: { width: number; height: number }) {
  const types = template === "overview" ? ["kpi", "kpi", "kpi", "line"] : template === "analysis" ? ["bar", "pie"] : ["table"]
  return [
    { type: "header", layout: { x: 32, y: 24, w: canvas.width - 64, h: 80 } },
    ...types.map((type, index) => {
      const columns = template === "overview" && index < 3 ? 3 : template === "analysis" ? 2 : 1
      return {
        type,
        layout: {
          x: 32 + index % columns * (canvas.width - 48) / columns,
          y: template === "overview" && index === 3 ? 300 : 130,
          w: (canvas.width - 48) / columns - 16,
          h: type === "kpi" ? 140 : canvas.height - (template === "overview" ? 340 : 180),
        },
      }
    }),
  ]
}
